import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../lib/api';

/**
 * AuthCallback — processes the Emergent OAuth session_id from the URL fragment.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/admin/login', { replace: true });
      return;
    }

    const sessionId = match[1];

    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!res.ok) throw new Error('Session exchange failed');

        const data = await res.json();

        // Store session token for API calls
        localStorage.setItem('argus_session_token', data.session_token);
        localStorage.setItem('argus_user', JSON.stringify(data));

        // Navigate to command center with user data
        navigate('/admin/command-center', {
          replace: true,
          state: { user: data, isNew: data.is_new },
        });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/admin/login', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#040F49] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
